import { render, staticRenderFns } from "./CloneKnowledgeBaseModal.vue?vue&type=template&id=91edea26&scoped=true&"
import script from "./CloneKnowledgeBaseModal.vue?vue&type=script&lang=js&"
export * from "./CloneKnowledgeBaseModal.vue?vue&type=script&lang=js&"
import style0 from "./CloneKnowledgeBaseModal.vue?vue&type=style&index=0&id=91edea26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91edea26",
  null
  
)

export default component.exports